import {
  validatePresence,
  validateInclusion,
} from 'ember-changeset-validations/validators';

export default {
  name: validatePresence(true),
  active: validateInclusion({ list: [true, false] }),
};
